import { SortBy } from '@common/enums';
import { Filter, SelectedItemMap } from '@common/models';
import { RootState } from '@redux/store';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type FaucetFilters = Record<string, Filter>;

interface FaucetState {
    selectedFaucets: SelectedItemMap;
    faucetFilters?: FaucetFilters;
    sortBy?: SortBy;
}

const initialState: FaucetState = {
    selectedFaucets: new Map(),
    faucetFilters: undefined,
    sortBy: SortBy.None,
};

const faucetSlice = createSlice({
    name: 'faucet',
    initialState,
    reducers: {
        updateSelectedFaucets: (state, action: PayloadAction<SelectedItemMap>) => {
            state.selectedFaucets = action.payload;
        },
        updateFaucetFilters: (state, action: PayloadAction<FaucetFilters>) => {
            state.faucetFilters = action.payload;
        },
        resetFaucets: (state) => {
            state.selectedFaucets = initialState.selectedFaucets;
            state.faucetFilters = initialState.faucetFilters;
        },
        updateFaucetsSortBy: (state, action: PayloadAction<SortBy | undefined>) => {
            if (state.sortBy === action.payload || action.payload === undefined) {
                state.sortBy = SortBy.None;
            } else {
                state.sortBy = action.payload;
            }
        },
    },
});

export const { updateSelectedFaucets, updateFaucetFilters, resetFaucets, updateFaucetsSortBy } = faucetSlice.actions;

export default faucetSlice.reducer;

export const selectSelectedFaucets = ({ faucet }: RootState): SelectedItemMap => {
    return faucet.selectedFaucets;
};

export const selectFaucetFilters = ({ faucet }: RootState): FaucetFilters | undefined => faucet.faucetFilters;

export const selectFaucetSortBy = ({ faucet }: RootState): SortBy | undefined => faucet.sortBy;
